import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { Subscription, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { WebSocketsService } from '../../../services/web-sockets.service';
import { ImportItem } from '../../../interfaces/importItem';
import { SapiService } from '../../../services/sapi.service';
import { UploadService } from '../../../services/upload.service';
import { Mediaclip } from '../../../interfaces/mediaclip';
import { AuthenticationService } from '../../../services/authentication.service';

@Component({
	selector: 'bb-import',
	templateUrl: './bb-import.component.html',
	styleUrls: ['./bb-import.component.scss']
})

export class BbImportComponent implements OnInit, OnDestroy {

	@Input() autoPublish: boolean;
	@Input() importUrl: string;
	@Input() usetype: string;
	@Input() subusetype: string[];
	@Input() placeholder: string;
	@Input() transcodingProfile: string;

	@Output() importJobClipCreated: EventEmitter<Mediaclip>;

	// TODO: implement import busy
	public importBusy: boolean;

	subscriptions: Subscription;
	importedItems: ImportItem[];
	waitForImport: boolean;
	disableImport = false;
	putRight: boolean;

	constructor(
		private authenticationService: AuthenticationService,
		private webSocketsService: WebSocketsService,
		private sapiService: SapiService,
		private uploadService: UploadService
	) {
		this.importJobClipCreated = new EventEmitter<Mediaclip>();
		this.subscriptions = new Subscription();
		this.importedItems = [];
		this.importUrl = '';
		this.placeholder = '';
		this.authenticationService.hasPermission('put').subscribe(hasRight => this.putRight = hasRight);
		this.subscriptions = new Subscription();
	}

	ngOnInit() {
		this.subscriptions.add(this.webSocketsService.subscribeToChannel('import').subscribe((websocketEvent: any) => {
			if (websocketEvent && websocketEvent.Object && websocketEvent.ev) {
				if (websocketEvent.ev === 'importJobClipCreated') {
					this.importJobClipCreated.emit();
				}
			}
		}));
	}

	ngOnDestroy() {
		if (this.subscriptions) {
			this.subscriptions.unsubscribe();
		}
	}

	import() {
		let data: any = {};
		if (this.importUrl && this.importUrl.length > 0) {
			this.importUrl = this.importUrl.trim();
			data = {
				url: this.importUrl,
				autoPublish: this.autoPublish,
			};
			if (this.usetype && this.subusetype) {
				data.usetype = this.usetype;
				data.subusetype = this.subusetype;
			}
			if (this.transcodingProfile) {
				data.transcodingProfile = this.transcodingProfile;
			}
			this.waitForImport = true;
			this.sapiService.postUrl('/import', data)
				.pipe(
					catchError((error: any) => {
						const importItem: ImportItem = {
							label: '',
							status: 'error',
							autoPublish: true,
							srcUrl: this.importUrl,
							id: this.importUrl,
							type: 'ImportItem',
							message: { code: 'UNKNOWN_ERROR' },
							usetype: this.usetype,
							subusetype: this.subusetype,
							transcodingProfile: this.transcodingProfile

						};
						this.uploadService.onImport(importItem);
						return of(importItem);
					})
				)
				.subscribe((response: ImportItem) => {
					if (response) {
						if (response.type && response.type === 'ImportItem') {
							this.importedItems.push(response);
							this.uploadService.onImport(response);
							if (response.status !== 'error') {
								this.importUrl = '';
							}
						}
						this.waitForImport = false;
					}
				});
		}
	}
}
